import { type FC } from 'react';
import {
  UsersThree
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUsersThreeProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUsersThree: FC<UiIconUsersThreeProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UsersThree}
      {...props}
    />
  );
};
